const Actions = "";
const Adjustments = "Justeringar";
const All = "Alla";
const Amount = "Belopp";
const Contracts = "Avtal";
const Currency = "Valuta";
const Dates = "Datum";
const Filters = "Filter";
const Invoices = "Fakturor";
const Loans = "Lån";
const Overdue = "Försenad";
const Overview = "Översikt";
const Paid = "Betald";
const Payout = "Utbetalning";
const Reference = "Referens";
const Reports = "Rapporter";
const Retry = "";
const Sales = "Försäljning";
const State = "Status";
const Status = "Status";
const Turnover = "Omsättning";
const Type = "Typ";
const common = {
  Actions,
  Adjustments,
  All,
  Amount,
  "Checkout monthly fee": "Utkassamånadsavgift",
  Contracts,
  "Could not load invoices, please try again...": "",
  Currency,
  "Customer name": "",
  "Customer number": "Kundnummer",
  "Date": "Datum",
  Dates,
  "Due Date": "Förfallodatum",
  "Email is required": "E-post är obligatoriskt",
  Filters,
  "Invoice Date": "Fakturadatum",
  "Invoice preview": "Fakturaförhandsgranskning",
  Invoices,
  "Load more": "",
  Loans,
  "Login into merchant portal": "",
  "Merchant ID": "Handlar-ID",
  "Merchant Portal": "Handlarportal",
  "No PDF available": "",
  "No invoices found": "",
  "OCR / invoice number": "OCR / fakturanummer",
  "Oops, something went wrong": "",
  Overdue,
  Overview,
  Paid,
  "Password is required": "Lösenord är obligatoriskt",
  "Payment details": "Betalningsdetaljer",
  "Payment type": "Betalningstyp",
  Payout,
  "Please try again...": "",
  Reference,
  Reports,
  Retry,
  Sales,
  "Sales location": "Försäljningsplats",
  "Something went wrong": "",
  State,
  Status,
  "Total monthly fee ex. VAT (25%)": "Total månadsavgift exkl. moms (25%)",
  "Total monthly fee inc. VAT (25%)": "Total månadsavgift inkl. moms (25%)",
  "Try again": "",
  Turnover,
  Type,
  "View PDF": "",
  "Welcome to Worldline!": ""
};
export {
  Actions,
  Adjustments,
  All,
  Amount,
  Contracts,
  Currency,
  Dates,
  Filters,
  Invoices,
  Loans,
  Overdue,
  Overview,
  Paid,
  Payout,
  Reference,
  Reports,
  Retry,
  Sales,
  State,
  Status,
  Turnover,
  Type,
  common as default
};
